import React, { useState, useEffect } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
`

const LockBox = styled.div`
  background: ${(props) => props.theme.colors.ednBackground};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 12px;
  padding: 3rem 2rem;
  max-width: 400px;
  width: 100%;
  box-shadow: ${(props) => props.theme.colors.tableBoxShadow};
  text-align: center;
`

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 1rem;
`

const Description = styled.p`
  color: ${(props) => props.theme.colors.text200};
  margin-bottom: 2rem;
  font-size: 0.9rem;
`

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  background: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary};
  }
`

const Button = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.fail};
  font-size: 0.85rem;
  margin-bottom: 1rem;
  background: ${(props) => props.theme.colors.fail300};
  padding: 0.5rem;
  border-radius: 4px;
`

const AccessLock = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(false)
  const [code, setCode] = useState("")
  const [error, setError] = useState("")
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    // Check session storage on mount
    const authStatus = sessionStorage.getItem("gencode_access_granted")
    if (authStatus === "true") {
      setIsAuthorized(true)
    }
    setIsChecking(false)
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()

    // Check against the environment variable
    const validCode = process.env.GATSBY_GENCODE_ACCESS_CODE

    if (code === validCode) {
      sessionStorage.setItem("gencode_access_granted", "true")
      setIsAuthorized(true)
      setError("")
    } else {
      setError("Código inválido. Por favor intenta de nuevo.")
    }
  }

  // Prevent flash of protected content while checking session storage
  if (isChecking) {
    return <Container />
  }

  if (isAuthorized) {
    return <>{children}</>
  }

  return (
    <Container>
      <LockBox>
        <div style={{ marginBottom: "1.5rem" }}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: "var(--primary, #3b82f6)" }}
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0110 0v4"></path>
          </svg>
        </div>
        <Title>Acceso Restringido</Title>
        <Description>
          Gencode AI es un producto privado. Por favor, ingresa tu código de
          acceso para continuar.
        </Description>
        <form onSubmit={handleSubmit}>
          <Input
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Código de acceso"
            required
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <Button type="submit" disabled={!code}>
            Desbloquear Acceso
          </Button>
        </form>
      </LockBox>
    </Container>
  )
}

export default AccessLock
